export default "__VITE_ASSET__ee1390c0__"